import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getInviteStaffData as _getInviteStaffData, inviteStaffRegisterFn } from 'api/org/staff';
import store from 'storejs';
export default {
  props: {
    tableSelectArr: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      visible: false,
      disabled: false,
      register_staff_count: '',
      // 已激活员工数量
      no_register_staff_count: '',
      // 未激活员工数量
      isLoading: true,
      staff_ids: []
    };
  },
  computed: {
    selectLength: function selectLength() {
      return this.tableSelectArr && this.tableSelectArr.length;
    }
  },
  methods: {
    init: function init() {
      var _this = this;
      this.visible = true;
      if (!this.tableSelectArr.length) this.getInviteStaffData();else {
        this.register_staff_count = 0;
        this.no_register_staff_count = 0;
        this.tableSelectArr.forEach(function (item) {
          _this.staff_ids.push(item.staff_id);
          if (item.is_register_user === '1') _this.register_staff_count += 1;
          if (item.is_register_user === '0') _this.no_register_staff_count += 1;
        });
        this.isLoading = false;
      }
    },
    getInviteStaffData: function getInviteStaffData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // const query = { staff_ids: this.staff_ids }
              _this2.isLoading = true;
              _context.next = 3;
              return _getInviteStaffData();
            case 3:
              res = _context.sent;
              _this2.isLoading = false;
              _this2.register_staff_count = res.data.register_staff_count;
              _this2.no_register_staff_count = res.data.no_register_staff_count;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var query, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              query = {
                staff_ids: _this3.staff_ids
              };
              _context2.next = 3;
              return inviteStaffRegisterFn(query);
            case 3:
              res = _context2.sent;
              if (res && res.code === 1) {
                _this3.$emit('refreshDataList');
                _this3.$message.success(res.message);
                store.set('invalid-time', Date.now());
                _this3.visible = false;
                _this3.$emit('refreshTime');
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};